export const GetAllUsers = "/user_manager/all_users";
export const AddUser = "/user_manager/add_user";
export const UpdateUser = "/user_manager/update";
export const AddAccessLevelToUser = "/user_manager/add_access_level_to_user";
export const GetUserAuditHistory = "/user_manager/user_audit_history";
export const UnlockUser = "/user_manager/unlock-user";
export const LockUser = "/user_manager/lock-user";
